(function () {
    'use strict';


    angular
        .module('tikonApp')
        .controller('GeneralServiceItemController', GeneralServiceItemController);

    GeneralServiceItemController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'ServiceItem', 'ServiceOptionInfo', 'DiscountInfo', 'LocationInfo', 'AlbumInfo', 'ServiceCapacityInfo', 'ServiceCategory', 'PriceInfo', 'ScheduleInfo', 'Servant', 'AgreementInfo', 'MetaTag', 'ServiceCategoryCustom', 'CompanyCustom', '$translate', '$translatePartialLoader', '$state'];

    function GeneralServiceItemController($timeout, $scope, $stateParams, entity, ServiceItem, ServiceOptionInfo, DiscountInfo, LocationInfo, AlbumInfo, ServiceCapacityInfo, ServiceCategory, PriceInfo, ScheduleInfo, Servant, AgreementInfo, MetaTag, ServiceCategoryCustom, CompanyCustom, translate, translatePartialLoader, $state) {
        var vm = this;
        vm.scope = $scope;
        vm.scheduleFormState = 'list';
        vm.priceInfoFormState = "'list'";
        vm.serviceOptionInfoFormState = "'list'";
        vm.servantFormState = "'list'";
        vm.serviceItem = entity;
        vm.oldItem = angular.copy(vm.serviceItem);
        vm.mainScheduleType = 'BASED_ON_COMPANY_SCHEDULE';
        vm.saveAndGotoScheduling = saveAndGotoScheduling;
        vm.weekDayExists = weekDayExists;
        vm.toggleWeekDay = toggleWeekDay;
        vm.weekDays = ['SATURDAY', 'SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'];


        //vm.clear = clear;
        vm.save = save;
        vm.categoryName = categoryName;
        vm.showFullDescription = showFullDescription;
        vm.fullDescription = false;
        vm.showAdvancedSetting = showAdvancedSetting;
        vm.advancedSetting = false;
        //vm.serviceoptioninfos = ServiceOptionInfo.query();
        //vm.discountinfos = DiscountInfo.query();
        //vm.locationinfos = LocationInfo.query();
        //vm.albuminfos = AlbumInfo.query();
        //vm.servicecapacityinfos = ServiceCapacityInfo.query();
        //vm.servicecategories = ServiceCategory.query();
        //
        vm.showDuration = showDuration;
        vm.confirmationType_Change = confirmationType_Change;
        if (vm.serviceItem.multiReserveMode == undefined)
            vm.serviceItem.multiReserveMode = "DISABLE";

        initDefault();

        ServiceCategoryCustom.getServiceCategoriesByCurrentCompany().query().$promise.then(function (result) {


            vm.servicecategories = result;

            if (vm.serviceItem.category == null || vm.serviceItem.category == undefined || vm.serviceItem.category.id == null || vm.serviceItem.category.id == undefined) {
                angular.forEach(result, function (category) {
                    if (category.categoryName == "DEFAULT_CATEGORY") {
                        vm.serviceItem.category = category;
                    }

                });
            }
            translatePartialLoader.addPart('serviceItem');
            translatePartialLoader = translate.refresh();

        });

        if (vm.serviceItem.maxPreReserveTime == null || vm.serviceItem.maxPreReserveTime == undefined)
            vm.serviceItem.maxPreReserveTime = 20;
        if (vm.serviceItem.minPreReserveTime == null || vm.serviceItem.minPreReserveTime == undefined)
            vm.serviceItem.minPreReserveTime = 0;


        //vm.priceinfos = PriceInfo.query();
        //vm.scheduleinfos = ScheduleInfo.query();
        //vm.servants = Servant.query();
        //vm.agreementinfos = AgreementInfo.query();
        //vm.metatags = MetaTag.query();
        vm.paymentType_changed = paymentType_changed;
        vm.priceInfoFormReload = false;
        //   vm.currentScheduleInfo= vm.serviceItem.scheduleInfo;
        //   vm.backToList=backToList;
        //   vm.onSelectedScheduleChanged=onSelectedScheduleChanged;
        //   vm.onCreateNewSchedule=onCreateNewSchedule;
        findCurrentCompany();


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });


        if (vm.serviceItem.amenities == null || vm.serviceItem.amenities == undefined) {
            vm.serviceItem.amenities = {};
            vm.serviceItem.amenities.amenitiesList = [];
        }


        function findCurrentCompany() {
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {

                vm.currentCompany = result;
                if (vm.currentCompany.activityType == 'WORK_SPACE') {
                    vm.priceInfoType = "fixed";
                }
            });
        }


        //
        //function clear () {
        //    $uibModalInstance.dismiss('cancel');
        //}

        function save() {
            updateScheduleTypeFromMainType();
            checkIfScheduleRegenerationNeeded();
            vm.priceInfoFormReload = 'false';

            if (vm.scope.editForm.$valid) {
                vm.isSaving = true;

                if (vm.serviceItem.id !== null) {

                    ServiceItem.update(vm.serviceItem, onSaveSuccess, onSaveError);
                } else {
                    ServiceItem.save(vm.serviceItem, onSaveSuccess, onSaveError);

                }
            }
        }

        function onSaveSuccess(result) {

            $scope.$emit('tikonApp:serviceItemUpdate', result);

            vm.serviceItem = result;
            vm.oldItem = angular.copy(vm.serviceItem);
            //    vm.serviceItem.scheduleInfo= ScheduleInfo.get({id : result.scheduleInfo.id});
            //$uibModalInstance.close(result);

            vm.priceInfoFormReload = 'true';
            vm.priceInfoFormState = 'list';
            vm.serviceOptionInfoFormState = 'list';
            vm.isSaving = false;

            if (vm.nextGotoScheduling) {
                $state.go('supplierPanel.scheduling', {id: vm.serviceItem.id});
            }

        }

        function backToList() {

            vm.scheduleFormState = 'list';
            vm.selectedScheduleId = '';
        }

        function onSelectedScheduleChanged(data) {

            //    vm.serviceItem.scheduleInfo= ScheduleInfo.get({id : data.id});

        }

        function onCreateNewSchedule() {

            vm.serviceItem.scheduleInfo = {};

        }

        function onCreateNewPriceInfo() {
            //

            vm.serviceItem.priceInfo = {};

        }

        function onSelectedPriceInfoChanged(data) {
            //
            //vm.serviceItem.priceInfo= PriceInfo.get({id : data.id});

        }

        function onSaveError() {
            vm.isSaving = false;
            vm.nextGotoScheduling = false;
        }


        function paymentType_changed() {

            if (vm.serviceItem.paymentType == "PAYMENT_ALL") {
                vm.serviceItem.prePaymentAmount = 0;
            }
            if (vm.serviceItem.paymentType == "PRE_PAYMENT") {
                vm.serviceItem.inPlacePayment = false;
            }

        }

        function categoryName(name) {
            if (name == "DEFAULT_CATEGORY")
                return translate.instant('tikonApp.serviceItem.' + name);
            else
                return name;
        }

        function showFullDescription() {
            vm.fullDescription = !vm.fullDescription;
        }

        function showAdvancedSetting() {
            vm.advancedSetting = !vm.advancedSetting;
        }

        function initDefault() {
            if (vm.serviceItem.serviceStatus == null || vm.serviceItem.serviceStatus == undefined)
                vm.serviceItem.serviceStatus = 'PUBLISH';

            if (vm.serviceItem.paymentType == null || vm.serviceItem.paymentType == undefined)
                vm.serviceItem.paymentType = 'PAYMENT_ALL';

            if (vm.serviceItem.confirmationType == null || vm.serviceItem.confirmationType == undefined)
                vm.serviceItem.confirmationType = 'ONE_STEP';

            if (vm.serviceItem.capacityInfo == null || vm.serviceItem.capacityInfo == undefined || vm.serviceItem.capacityInfo.qty == null || vm.serviceItem.capacityInfo.qty == undefined) {
                vm.serviceItem.capacityInfo = {};
                vm.serviceItem.capacityInfo.qty = 1;
            }
            if (!vm.serviceItem.duration)
                vm.serviceItem.duration = 60;

            setMainScheduleType()
        }

        function setMainScheduleType() {
            if (vm.serviceItem.scheduleInfo && vm.serviceItem.scheduleInfo.scheduleType) {
                var currentType = vm.serviceItem.scheduleInfo.scheduleType;
                if (currentType == 'BASED_ON_COMPANY_SCHEDULE' || currentType == 'PRIMARY' || currentType == 'FLOAT_TIME_SESSIONS') {
                    vm.mainScheduleType = 'BASED_ON_COMPANY_SCHEDULE';
                    if (vm.serviceItem.consecutiveReserveMode != 'DISABLE')
                        vm.serviceItem.consecutiveReserveMode = 'ENABLE';
                } else if (currentType == 'FIXED_TIME_SESSIONS') {
                    vm.mainScheduleType = 'FIXED_TIME_SESSIONS';
                } else {
                    vm.mainScheduleType = 'BASED_ON_COMPANY_SCHEDULE';
                }
            }
        }

        function updateScheduleTypeFromMainType() {

            if (vm.serviceItem.scheduleInfo && vm.serviceItem.scheduleInfo.scheduleType) {
                var currentType = vm.serviceItem.scheduleInfo.scheduleType;
                if (currentType == 'BASED_ON_COMPANY_SCHEDULE' || currentType == 'PRIMARY' || currentType == 'FLOAT_TIME_SESSIONS') {
                    if (vm.mainScheduleType == 'FIXED_TIME_SESSIONS') {
                        currentType = 'FIXED_TIME_SESSIONS'
                    }

                } else if (currentType == 'FIXED_TIME_SESSIONS') {
                    if (vm.mainScheduleType != 'FIXED_TIME_SESSIONS')
                        currentType = 'BASED_ON_COMPANY_SCHEDULE';
                } else {
                    currentType = 'BASED_ON_COMPANY_SCHEDULE';
                }
                vm.serviceItem.scheduleInfo.scheduleType = currentType;
            } else {
                var currentType = 'BASED_ON_COMPANY_SCHEDULE';
                if (vm.mainScheduleType == 'FIXED_TIME_SESSIONS') {
                    currentType = 'FIXED_TIME_SESSIONS'
                }
                if (!vm.serviceItem.scheduleInfo) vm.serviceItem.scheduleInfo = {};
                vm.serviceItem.scheduleInfo.scheduleType = currentType;
            }
        }

        function saveAndGotoScheduling() {
            vm.nextGotoScheduling = true;
            vm.save();
        }

        function checkIfScheduleRegenerationNeeded() {

            vm.scheduleGenerationNeeded = false;
            if (vm.oldItem && vm.oldItem.scheduleInfo && vm.serviceItem && vm.serviceItem.scheduleInfo && vm.oldItem.scheduleInfo.scheduleType != vm.serviceItem.scheduleInfo.scheduleType) {
                vm.serviceItem.scheduleGenerationNeeded = true;
            } else if (vm.oldItem.duration != vm.serviceItem.duration ||
                (vm.oldItem.capacityInfo && vm.oldItem.capacityInfo.qty != vm.serviceItem.capacityInfo.qty) ||
                vm.oldItem.maxPreReserveTime != vm.serviceItem.maxPreReserveTime) {
                vm.serviceItem.scheduleGenerationNeeded = true;
            } else {
                //checking servants
                if (vm.oldItem.servants.length != vm.serviceItem.servants.length)
                    vm.serviceItem.scheduleGenerationNeeded = true;
                else {
                    if (vm.oldItem.servants.length > 0) {
                        angular.forEach(vm.oldItem.servants, function (os) {
                            var isInList = false;
                            angular.forEach(vm.serviceItem.servants, function (ns) {
                                if (ns.id == os.id)
                                    isInList = true;
                            });
                            if (!isInList)
                                vm.serviceItem.scheduleGenerationNeeded = true;
                        })
                    }
                }

            }
        }

        function showDuration() {

            if (vm.mainScheduleType == 'FIXED_TIME_SESSIONS')
                return false;

            if (vm.serviceItem == null || vm.serviceItem.serviceTimes == null)
                return true;

            if (vm.serviceItem.serviceTimes != null && vm.serviceItem.serviceTimes != undefined
                && vm.serviceItem.serviceTimes.length == 1 && vm.serviceItem.serviceTimes[0].scheduleType == 'BASED_ON_COMPANY_SCHEDULE'
            ) {
                return true;
            }

        }

        function confirmationType_Change() {
            if (vm.serviceItem.confirmationType != null && vm.serviceItem.confirmationType != undefined
                && vm.serviceItem.confirmationType == 'TWO_STEP'

            ) {
                if (vm.serviceItem.customerConfirmationDeadline == null || vm.serviceItem.customerConfirmationDeadline == undefined || vm.serviceItem.customerConfirmationDeadline == 0) {
                    vm.serviceItem.customerConfirmationDeadline = 24;
                }
            }
        }

        function weekDayExists(weekDay) {
            var selectedWeekDay = vm.serviceItem.multiReserveConfig.repeatOnWeekdays;
            var isExist = false;
            if (selectedWeekDay != undefined)
                angular.forEach(selectedWeekDay, function (item) {
                    if (item == weekDay)
                        isExist = true;
                });
            return isExist;

        }

        function toggleWeekDay(weekDay) {
            var selectedWeekDay = vm.serviceItem.multiReserveConfig.repeatOnWeekdays;
            if (selectedWeekDay == undefined)
                vm.serviceItem.multiReserveConfig.repeatOnWeekdays = [];

            if (vm.weekDayExists(weekDay, selectedWeekDay)) {
                var index = selectedWeekDay.indexOf(weekDay);
                vm.serviceItem.multiReserveConfig.repeatOnWeekdays.splice(index, 1);
            } else {
                vm.serviceItem.multiReserveConfig.repeatOnWeekdays.push(weekDay);
            }

        }
    }
})();
